<!-- eslint-disable max-len -->
<template>
  <svg fill="none" height="24" stroke-width="1.5" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 13V8C19 6.14348 18.2625 4.36301 16.9497 3.05025C15.637 1.7375 13.8565 1 12 1C10.1435 1 8.36301 1.7375 7.05025 3.05025C5.7375 4.36301 5 6.14348 5 8V13C4.97026 15.47 4.27968 17.8871 3 20H21C19.7203 17.8871 19.0297 15.47 19 13Z"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
    />
    <path
      class="v-icon-fill-color"
      d="M9.17383 22C9.38162 22.5832 9.76478 23.0879 10.2707 23.4447C10.7767 23.8016 11.3807 23.9932 11.9998 23.9932C12.619 23.9932 13.223 23.8016 13.7289 23.4447C14.2349 23.0879 14.618 22.5832 14.8258 22H9.17383Z"
      stroke-width="1"
    />
  </svg>
</template>
